export const OS_TYPES = {
  IOS: 'ios',
  ANDROID: 'android',
  OTHER: 'other'
}

export const IPHONE_MODELS = [
  { value: 'iphone-17-pro-max', label: 'iPhone 17 Pro Max', connector: 'usbc' },
  { value: 'iphone-17-pro', label: 'iPhone 17 Pro', connector: 'usbc' },
  { value: 'iphone-17-air', label: 'iPhone 17 Air', connector: 'usbc' },
  { value: 'iphone-17-plus', label: 'iPhone 17 Plus', connector: 'usbc' },
  { value: 'iphone-17', label: 'iPhone 17', connector: 'usbc' },
  { value: 'iphone-16-pro-max', label: 'iPhone 16 Pro Max', connector: 'usbc' },
  { value: 'iphone-16-pro', label: 'iPhone 16 Pro', connector: 'usbc' },
  { value: 'iphone-16-plus', label: 'iPhone 16 Plus', connector: 'usbc' },
  { value: 'iphone-16', label: 'iPhone 16', connector: 'usbc' },
  { value: 'iphone-15-pro-max', label: 'iPhone 15 Pro Max', connector: 'usbc' },
  { value: 'iphone-15-pro', label: 'iPhone 15 Pro', connector: 'usbc' },
  { value: 'iphone-15-plus', label: 'iPhone 15 Plus', connector: 'usbc' },
  { value: 'iphone-15', label: 'iPhone 15', connector: 'usbc' },
  { value: 'iphone-14-pro-max', label: 'iPhone 14 Pro Max', connector: 'lightning' },
  { value: 'iphone-14-pro', label: 'iPhone 14 Pro', connector: 'lightning' },
  { value: 'iphone-14-plus', label: 'iPhone 14 Plus', connector: 'lightning' },
  { value: 'iphone-14', label: 'iPhone 14', connector: 'lightning' },
  { value: 'iphone-13-pro-max', label: 'iPhone 13 Pro Max', connector: 'lightning' },
  { value: 'iphone-13-pro', label: 'iPhone 13 Pro', connector: 'lightning' },
  { value: 'iphone-13', label: 'iPhone 13', connector: 'lightning' },
  { value: 'iphone-13-mini', label: 'iPhone 13 Mini', connector: 'lightning' },
  { value: 'iphone-12-pro-max', label: 'iPhone 12 Pro Max', connector: 'lightning' },
  { value: 'iphone-12-pro', label: 'iPhone 12 Pro', connector: 'lightning' },
  { value: 'iphone-12', label: 'iPhone 12', connector: 'lightning' },
  { value: 'iphone-12-mini', label: 'iPhone 12 Mini', connector: 'lightning' },
  { value: 'iphone-11-pro-max', label: 'iPhone 11 Pro Max', connector: 'lightning' },
  { value: 'iphone-11-pro', label: 'iPhone 11 Pro', connector: 'lightning' },
  { value: 'iphone-11', label: 'iPhone 11', connector: 'lightning' },
  { value: 'iphone-xs-max', label: 'iPhone XS Max', connector: 'lightning' },
  { value: 'iphone-xs', label: 'iPhone XS', connector: 'lightning' },
  { value: 'iphone-xr', label: 'iPhone XR', connector: 'lightning' },
  { value: 'iphone-x', label: 'iPhone X', connector: 'lightning' },
  { value: 'iphone-8-plus', label: 'iPhone 8 Plus', connector: 'lightning' },
  { value: 'iphone-8', label: 'iPhone 8', connector: 'lightning' },
  { value: 'iphone-older', label: 'Older iPhone', connector: 'lightning' },
  { value: 'iphone-unknown', label: "I don't know", connector: null }
]

export const ANDROID_CONNECTORS = [
  { value: 'usbc', label: 'USB-C' },
  { value: 'micro-usb', label: 'Micro-USB' },
  { value: 'unknown', label: "I don't know" }
]

export const PIXEL_MODELS = [
  { value: 'pixel-10-pro-fold', label: 'Pixel 10 Pro Fold' },
  { value: 'pixel-10-pro-xl', label: 'Pixel 10 Pro XL' },
  { value: 'pixel-10-pro', label: 'Pixel 10 Pro' },
  { value: 'pixel-10', label: 'Pixel 10' },
  { value: 'pixel-10a', label: 'Pixel 10a' },
  { value: 'pixel-9-pro-fold', label: 'Pixel 9 Pro Fold' },
  { value: 'pixel-9-pro-xl', label: 'Pixel 9 Pro XL' },
  { value: 'pixel-9-pro', label: 'Pixel 9 Pro' },
  { value: 'pixel-9', label: 'Pixel 9' },
  { value: 'pixel-9a', label: 'Pixel 9a' },
  { value: 'pixel-8-pro', label: 'Pixel 8 Pro' },
  { value: 'pixel-8', label: 'Pixel 8' },
  { value: 'pixel-8a', label: 'Pixel 8a' },
  { value: 'pixel-7-pro', label: 'Pixel 7 Pro' },
  { value: 'pixel-7', label: 'Pixel 7' },
  { value: 'pixel-7a', label: 'Pixel 7a' },
  { value: 'pixel-6-pro', label: 'Pixel 6 Pro' },
  { value: 'pixel-6', label: 'Pixel 6' },
  { value: 'pixel-6a', label: 'Pixel 6a' },
  { value: 'pixel-fold', label: 'Pixel Fold' }
]

export const SAMSUNG_MODELS = [
  { value: 'samsung-galaxy-s25-ultra', label: 'Samsung Galaxy S25 Ultra' },
  { value: 'samsung-galaxy-s25-plus', label: 'Samsung Galaxy S25+' },
  { value: 'samsung-galaxy-s25', label: 'Samsung Galaxy S25' },
  { value: 'samsung-galaxy-s24-ultra', label: 'Samsung Galaxy S24 Ultra' },
  { value: 'samsung-galaxy-s24-plus', label: 'Samsung Galaxy S24+' },
  { value: 'samsung-galaxy-s24', label: 'Samsung Galaxy S24' },
  { value: 'samsung-galaxy-s23-ultra', label: 'Samsung Galaxy S23 Ultra' },
  { value: 'samsung-galaxy-s23-plus', label: 'Samsung Galaxy S23+' },
  { value: 'samsung-galaxy-s23', label: 'Samsung Galaxy S23' },
  { value: 'samsung-galaxy-s23-fe', label: 'Samsung Galaxy S23 FE' },
  { value: 'samsung-galaxy-s22-ultra', label: 'Samsung Galaxy S22 Ultra' },
  { value: 'samsung-galaxy-s22-plus', label: 'Samsung Galaxy S22+' },
  { value: 'samsung-galaxy-s22', label: 'Samsung Galaxy S22' }
]

export const getConnectorForDevice = deviceValue =>
  IPHONE_MODELS.find(model => model.value === deviceValue)?.connector || null

export const formatDeviceDataForApi = ({ selectedOS, selectedDevice, androidModel }) => {
  if (selectedOS === OS_TYPES.IOS) {
    const matchedModel = IPHONE_MODELS.find(model => model.value === selectedDevice)
    return {
      deviceType: OS_TYPES.IOS,
      deviceModel: matchedModel?.label || null,
      deviceConnector: matchedModel?.connector || null
    }
  }

  if (selectedOS === OS_TYPES.ANDROID) {
    return {
      deviceType: OS_TYPES.ANDROID,
      deviceModel: androidModel?.trim() || null,
      deviceConnector: null
    }
  }

  if (selectedOS === OS_TYPES.OTHER) {
    return {
      deviceType: OS_TYPES.OTHER,
      deviceModel: null,
      deviceConnector: null
    }
  }

  return {
    deviceType: null,
    deviceModel: null,
    deviceConnector: null
  }
}
